import { GROUPS, PREFIX } from '@/service/apiConf';
import { get, postForm, postJSON } from '@/service/request';

const UrlMap = {
  summary: () => `${PREFIX.vapis_ws(GROUPS.ophub)}/cost-analysis/summary`,
  categoryProportions: () => `${PREFIX.vapis_ws(GROUPS.ophub)}/cost-analysis/category-proportions`,
  timeSeries: () => `${PREFIX.vapis_ws(GROUPS.ophub)}/cost-analysis/time-series`,
  transactions: () => `${PREFIX.vapis_ws(GROUPS.ophub)}/transactions`,
  systemConfig: () => `${PREFIX.vapis_ws(GROUPS.ophub)}/system-config`,
  preCreateId: () => `${PREFIX.vapis_ws(GROUPS.ophub)}/recharge-requests/pre-create`,
  rechargeRequests: () => `${PREFIX.vapis_ws(GROUPS.ophub)}/recharge-requests`,
  rechargeStatus: (id: string) => `${PREFIX.vapis_ws(GROUPS.ophub)}/recharge-requests/${id}`,
  cancelRecharge: (id: string) => `${PREFIX.vapis_ws(GROUPS.ophub)}/recharge-requests/${id}/cancel`,
};

// 费用总览
export function getSummary(params?: Record<string, any>) {
  return get<any>(UrlMap.summary(), params);
}

// 各产品类别费用占比
export function getCategoryProportions(params?: Record<string, any>) {
  return get<any>(UrlMap.categoryProportions(), params);
}

// 各产品类别费用占比 时序图
export function getTimeSeries(params?: Record<string, any>) {
  return get<any>(UrlMap.timeSeries(), params);
}

// 收支明细
export function getTransactions(params?: Record<string, any>) {
  return get<any>(UrlMap.transactions(), params);
}

// 系统对公转账的信息
export function getSystemConfig(params?: Record<string, any>) {
  return get<any>(UrlMap.systemConfig(), params);
}

// 预创建充值Id获取
export function preCreateId(params?: Record<string, any>) {
  return postForm<any>(UrlMap.preCreateId(), params);
}

// 充值请求
export function rechargeRequests(params?: Record<string, any>) {
  return postJSON<any>(UrlMap.rechargeRequests(), params);
}

// 充值记录
export function getRechargeRequests(params?: Record<string, any>) {
  return get<any>(UrlMap.rechargeRequests(), params);
}

// 充值状态
export function getRechargeStatus(id: string, params?: Record<string, any>) {
  return get<any>(UrlMap.rechargeStatus(id), params, { flag: true });
}

// 取消支付
export function cancelRecharge(id: string, params?: Record<string, any>) {
  return postJSON<any>(UrlMap.cancelRecharge(id), params);
}
